import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldSchema } from '@lsq-frontend/remote-services/ar-app';
import { ModalService } from '@lsq-frontend/common-ui';

@Component({
    selector: 'add-document-modal',
    templateUrl: './add-document-modal.component.html',
    styleUrls: ['./add-document-modal.component.scss']
})
export class AddDocumentModal {
    public formGroup: FormGroup;
    public fieldSchema: FieldSchema;
    public schemaType: string;

    constructor(private _modalService: ModalService) {
        this.formGroup = this._modalService.modal.data.formGroup;
        this.fieldSchema = this._modalService.modal.data.fieldSchema;
        this.schemaType = this._modalService.modal.data.schemaType;
    }
    public fileOptions = [
        {
            label: 'All',
            value: '*'
        },
        {
            label: 'PDF',
            value: '.pdf'
        },
        {
            label: 'PNG',
            value: '.png'
        },
        {
            label: 'JPG',
            value: '.jpg'
        },
        {
            label: 'GIF',
            value: '.gif'
        },
        {
            label: 'CSV',
            value: '.csv'
        },
        {
            label: 'XLS',
            value: '.xls'
        },
        {
            label: 'XLSX',
            value: '.xlsx'
        }
    ];
}
